var qvkey = "";sort='rating';sorta=true;var initClassFlags = 0; var initRoomFlags = 0; var sfRoom = new Array(); var sfClass= new Array();

function showpins() { mShowPagedResults() }

function GetPinData() { GetHotelPinData() }


$(document).ready(function () {
    $(".btnFilter").click(function () {
        bApplySTT = false;
        trackView('Filter', '', '', true, true);
        resetMap();
        $(this).closest(".dropdown-menu").toggle();
        $(this).closest(".form-dropdown").find(".dropdown-toggle").attr('aria-expanded', 'false'); 
        return false;
    });

    $("#deskamen35").change(function () {
                $("#mobileamen35").prop("checked", $("#deskamen35").prop("checked"))
             bApplySTT = false;
               trackView('Filter', '', '', true, true);
                resetMap();
                return false;
     })
        
           $("#mobileamen35").change(function () {
             $("#deskamen35").prop("checked", $("#mobileamen35").prop("checked"))
             bApplySTT = false;
                    trackView('Filter', '', '', true, true);
                    resetMap();
                   return false;
             })
    

    fInitFilterState(true)

})


var sfb = new Array(64, 256, 8, 2048, 4194304, 4, 32, 128, 16, 1024, 512, 262144, 2097152, 65536, 524288, 8192, 32768, 1, 2, 4096, 16384, 1048576, 131072, 268435456, 4294967296, 536870912, 1073741824, 2147483648, 8589934592, 17179869184, 34359738368, 68719476736, 137438953472, 274877906944, 549755813888, 4398046511104)
var sfbRoom = new Array(1, 2, 4, 8 );
var sfbClass = new Array(512, 256, 128, 64, 32, 16, 8, 4, 2, 1);

function fInitFilterState(b) {
    var qs = getQueryString();
    if (qs["rm"]) { $("#venue-guest-rooms-" + qs["rm"]).prop('checked', true); }
    if (qs["mspc"]) { $("#venue-meeting-space-" + qs["mspc"]).prop('checked', true); }
    if (qs["cls"]) { $("#venue-class-" + qs["cls"]).prop('checked', true); }
    if (qs["tst"]) { $("#deskamen35").prop('checked', true); }
    if (qs["tst"]) { $("#mobileamen35").prop('checked', true); }
      var chk;
      if (intSFvs != 0 || b) {
          for (var k = 0; k < sfb.length; k++) {
              if ($("#amen" + k).length > 0) {
                  $("#amen" + k).prop("checked", (AND(intSFvs, sfb[k]) == sfb[k]))
              }
          }
      };
    
      intSFvs = 0; initClassFlags = 0; initRoomFlags = 0;
	
    }
 
 function fInitFilterflags(r) {
 	sfRoom = new Array(); sfClass = new Array();
 	sfRoom = r.RoomFlagsString.split("|");
 	sfClass = r.ClassFlagsString.split("|");
 }



function getPropType() {
    var s = "";
    $('.typeClass:checked').map(function () { s = s + $(this).val() + "|"; })
    return s
}

function getPropChainKeys() {
    var s = "";
    $('.typeChain:checked').map(function () { s = s + $(this).val() + "|"; })
    return s;
}


function typeinitResults() { }
 
function _srchst() {

	var b = _gsrchst(new Object())
	b.SearchFlags = __flags();
	
	b.ClassFlags = __classflags()     
    b.Rooms = $("input[name='venue-guest-rooms']:checked").val();   
    b.MtgTotalRms = $("input[name='venue-meeting-room']:checked").val();
    b.MtgLgSqFt = $("input[name='venue-largest-room']:checked").val();
    b.MtgTotalRmSpace = $("input[name='venue-meeting-space']:checked").val();
    b.BoothsAccommodated = $("input[name='venue-booths']:checked").val();
    b.TotalExhibitSpace = $("input[name='venue-exhibits']:checked").val();
    b.PropType = getPropType();
    b.ChainKeys = getPropChainKeys();

	return b
}

function __flags() {
	var bw = 0;
	for (var k = 0; k < sfb.length; k++) {
        if ($("#venue-pref-amen" + k).length > 0) {
            if ($("#venue-pref-amen" + k).prop("checked")) { bw += parseInt(sfb[k]) }
		}
    }
    if ($("#deskamen35").length > 0 || $("#mobileamen35").length) {
        if ($("#deskamen35").prop("checked") || $("#mobileamen35").prop("checked")) { bw += parseInt(sfb[35]) }
    }
	return bw;
}

function __classflags() {
	var bw = 0;
	for (var k = 0; k < sfbClass.length; k++) {
        if ($("#venue-class-" + (k+1)).length > 0) {
            if ($("#venue-class-" + (k+1)).prop("checked")) { bw += parseInt(sfbClass[k]) }
		}
    }
    if ($("#venue-class-110").prop("checked")) { bw += parseInt(sfbClass[9]) + parseInt(sfbClass[8]) + parseInt(sfbClass[7]); }
    if ($("#venue-class-107").prop("checked")) { bw += parseInt(sfbClass[6]) + parseInt(sfbClass[5]) + parseInt(sfbClass[4]) + parseInt(sfbClass[3]); }
    if ($("#venue-class-103").prop("checked")) { bw += parseInt(sfbClass[2]) + parseInt(sfbClass[1]) + parseInt(sfbClass[0]) ; }
	return bw;
}

function __roomflags() {
	var bw = 0;
	for (var k = 0; k < sfbRoom.length; k++) {
		if ($("#rm" + k).length > 0) {
			if ($("#rm" + k).prop("checked")) { bw += parseInt(sfbRoom[k]) }
		}
	}
	return bw;
}

function restoreState() {
       grestoreState()
       if (oSearch) {

           intSFvs = oSearch.SearchFlags
           initClassFlags = oSearch.ClassFlags
         
           if (oSearch.Rooms > 0) { $("#venue-guest-rooms-" + oSearch.Rooms).prop('checked', true); }
           if (oSearch.MtgTotalRms > 0) { $("#venue-meeting-rooms-" + oSearch.MtgTotalRms).prop('checked', true); }
           if (oSearch.MtgLgSqFt > 0) { $("#venue-largest-room-" + oSearch.MtgLgSqFt).prop('checked', true); }
           if (oSearch.MtgTotalRmSpace > 0) { $("#venue-meeting-space-" + oSearch.MtgTotalRmSpace).prop('checked', true); }
           

            $('.typeClass').map(function () { $(this).attr("checked", oSearch.PropType.indexOf($(this).val()) > -1) })

            fInitFilterState(true)            
            if (!bMapView) { bIsHistory = false; }
           
       }
   }

   function parmstring() {

    var parms=""
		var chain = $(".drpChain").val()
		var rooms = __roomflags();
		var nclass = __classflags()
		var bw = __flags();	

   	
		if (chain != '' && chain != '0') { parms = parms + 'chn=' + chain + '&' }
		if (nclass != '' && nclass != '0') { parms = parms + 'cls=' + nclass + '&' }
		if (rooms != '' && rooms != '0') { parms = parms + 'rm=' + rooms + '&' }
		if (bw != '') { parms = parms + 'bw=' + bw + '&' }
	
		try { if (bUseBounds) { parms = parms + 'ub=1&' } } catch (e) { }
		try { if (mySearchBounds != null && mySearchBounds != '') { parms = parms + 'mb=' + escape(mySearchBounds) + '&' } } catch (e) { }
		if (!sorta) { parms = parms + 'stod=1&' }
	    if (sort!='rating'){parms=parms+ 'st=' + sort  + '&'}
		try { if (baseLat != 0 && baseLat != -999) { parms = parms + 'lat=' + baseLat + '&' } } catch (e) { }
		try { if (baseLong != 0 && baseLong != -999) { parms = parms + 'long=' + baseLong + '&' } } catch (e) { }
		try { if (baseMapLat != 0 && baseMapLat != -999) { parms = parms + 'mlat=' + baseMapLat + '&' } } catch (e) { }
		try { if (baseMapLong != 0 && baseMapLong != -999) { parms = parms + 'mlong=' + baseMapLong + '&' } } catch (e) { }
		try { if (baseZoom != 0) { parms = parms + 'bz=' + baseZoom + '&' } } catch (e) { }
		try { if (dn != '') { parms = parms + 'dn=' + escape(dn) + '&' } } catch (e) { }

		if (selcmp) { if (selcmp != "|") { parms = parms + 'selp=' + selcmp + '&' } }
		if (parms != '') { parms = parms.substring(0, parms.length - 1) }
		return parms;


   }
   
    function getQueryString() {
        var result = {}, queryString = location.search.slice(1),
            re = /([^&=]+)=([^&]*)/g, m;

        while (m = re.exec(queryString)) {
            result[decodeURIComponent(m[1])] = decodeURIComponent(m[2]);
        }

        return result;
    }
